import React, { useEffect, useRef } from 'react';
import './Footer.css';
import starknetLogoFlat from '../assets/starknetLogoFlat.png';
import strkw4 from '../assets/starkw4bottom.png';

const Footer = () => {
  const FooterRef = useRef(null);
  const imageRef = useRef(null); // Ref for the image

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          FooterRef.current.classList.add('appear');
          imageRef.current.classList.add('appear'); // Add appear class to the image
        }
      },
      { threshold: 0.5 }
    );

    observer.observe(FooterRef.current);

    return () => observer.disconnect();
  }, []);

  return (
    <div className="Footer">
      <img src={strkw4} alt="ALF" className="footer-image" ref={imageRef} /> {/* Attach ref */}
      <div className="Footer-container" ref={FooterRef}>
        <p className="disclaimer">
          ALF is a community coin with no intrinsic value or expectation of financial return.
        </p>
        <div className="starknet-logo-container">
          <img src={starknetLogoFlat} alt="Starknet Logo" className="starknet-logo" />
        </div>
      </div>
    </div>
  );
};

export default Footer;
